module.exports = __webpack_public_path__ + "img/logo-solena-black.d608fba6.png";